import React, { useState } from 'react';
import Modal from '../modal/Modal';
import * as styles from './UserDetailsPopupStyles';
import { registerUserForTrivia } from '../../services/apiRequests/TriviaService';
import { getFullNameObj } from '../../utils/watchAndWinUtils';
import { colors } from '../../styles/colors';
import { updateUserDetails } from '../../services/apiRequests/UserService';
import { useAppStore } from '../../hooks/useAppStore';

interface UserDetailsPopupProps {
  setIsUserOnBoarded: (flag: boolean) => void;
  gameMapperId: string;
}

const UserDetailsPopup: React.FC<UserDetailsPopupProps> = ({
  setIsUserOnBoarded,
  gameMapperId
}) => {
  const { setUsersData } = useAppStore();
  const [fullName, setFullName] = useState<string>('');
  const userInputValues = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFullName(event.target.value);
  };

  const submitData = async () => {
    const userInfo = getFullNameObj(fullName);

    await registerUserForTrivia({
      userName: `${userInfo.first_name || ''} ${userInfo.last_name || ''}`,
      region: '',
      mapperId: gameMapperId
    });

    const response = await updateUserDetails({
      firstName: userInfo?.first_name,
      lastName: userInfo?.last_name
    });

    if (response?.code == '1') {
      setUsersData({
        first_name: userInfo?.first_name,
        last_name: userInfo?.last_name
      });
      setIsUserOnBoarded(true);
    }
  };

  return (
    <Modal
      show={true}
      width={'400px'}
      height={'400px'}
      background={colors.SearchCardBg}
      renderCloseIcon={true}
      closeIconColor={colors.PrimaryWhiteColor}
      padding={'16px'}>
      <div css={styles.mainContainer}>
        <div css={styles.heading}>Enter Name</div>
        <div css={styles.textField}>
          <input
            css={styles.fullName}
            type="text"
            name="fullName"
            autoComplete="off"
            value={fullName}
            placeholder="Full Name"
            onChange={userInputValues}
            required
          />
        </div>
        <button
          css={styles.submitButton}
          type="button"
          disabled={!fullName.trim()}
          onClick={submitData}>
          <span css={styles.buttonText}>Save</span>
        </button>
      </div>
    </Modal>
  );
};

export default UserDetailsPopup;
